<template>
  <div>
    <b-field :label="`${fieldName}`">
      <b-dropdown
        multiple
        aria-role="list"
        class="checkbox-dropdown-field-container"
        :disabled="isDisabled"
      >
        <button
          class="button is-primary multi-select-button"
          type="button"
          slot="trigger"
          slot-scope="{ active }"
        >
          <span class="text-input">
            {{
              selectedIds.length > 0
                ? isAllOptionSelected
                  ? `All`
                  : `Selected ${filterTitle} (${selectedIds.length})`
                : `Select ${filterTitle}`
            }}
          </span>
          <b-icon
            class="dropdown-arrow-icon-down"
            type="is-black"
            :icon="active ? 'chevron-up' : 'chevron-down'"
            size="is-small"
          ></b-icon>
        </button>

        <b-dropdown-item
          :value="`All ${filterTitle}`"
          class="dropdown-checkbox all-item"
          :custom="true"
        >
          <div class="checkbox-container">
            <div class="column is-1 input-container width-auto">
              <input
                type="checkbox"
                value="true"
                @change="updateAllSelection(false)"
                v-model="isAllOptionSelected"
              />
            </div>
            <div class="column label-container align-left">
              <label
                class="break-next-line text-size-body width-full bold color-bold-text"
                @click="updateAllSelection(true)"
                :class="$style.applyMargin"
              >
                All {{ filterTitle }}
              </label>
            </div>
          </div>
        </b-dropdown-item>

        <b-dropdown-item
          :value="value.name"
          aria-role="listitem"
          v-for="(value, index) in filterList"
          :key="index"
          :class="[$style.dropdownItem, 'dropdown-checkbox']"
          :custom="true"
        >
          <div class="checkbox-container">
            <div class="column is-1 input-container width-auto">
              <input
                type="checkbox"
                :value="value.id"
                @change="updateSelection(false, value.id)"
                v-model="selectedIds"
              />
            </div>
            <div class="column label-container align-left">
              <label
                class="break-next-line text-size-body"
                @click="updateSelection(true, value.id)"
              >
                <span
                  class="break-next-line text-size-body width-full margin-bottom5"
                  >{{ value.name }}</span
                >
              </label>
            </div>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </b-field>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep as _cloneDeep } from 'lodash';
export interface FilterList {
  id: number;
  name: string;
}

@Component({ components: {} })
export default class BaseFilterDropdown extends Vue {
  @Prop()
  public filterTitle!: string;
  @Prop()
  public fieldName!: string;
  @Prop()
  public filterList!: FilterList[];
  @Prop({ default: false })
  public isDisabled!: boolean;
  public selectedIds: number[] = [];
  public isAllOptionSelected: boolean = true;
  public allIds: number[] = [];

  public mounted() {
    this.populateData();
  }

  public populateData() {
    this.filterList.map((single: any) => {
      this.selectedIds.push(single.id);
    });
    this.allIds = _cloneDeep(this.selectedIds);
  }

  public updateSelection(label: boolean = false, id: number) {
    if (label) {
      const idIndex = this.selectedIds.indexOf(id);
      if (idIndex === -1) {
        this.selectedIds.push(id);
      } else {
        this.selectedIds.splice(idIndex, 1);
      }
    }
    this.isAllOptionSelected = this.allIds.length === this.selectedIds.length;
    this.emitFilter();
  }

  public updateAllSelection(label: boolean = false) {
    if (label) {
      this.isAllOptionSelected = !this.isAllOptionSelected;
    }
    if (this.isAllOptionSelected) {
      this.selectedIds = _cloneDeep(this.allIds);
    } else {
      this.selectedIds = [];
    }
    this.emitFilter();
  }

  public mapOrder(selectedIds: number[], mapIds: number[]) {
    selectedIds.sort((selectedData, selectedNextData) => {
      if (mapIds.indexOf(selectedData) > mapIds.indexOf(selectedNextData)) {
        return 1;
      } else {
        return -1;
      }
    });
    return selectedIds;
  }

  public emitFilter() {
    if (this.selectedIds.length === 0 || this.selectedIds.length === 1) {
      this.$emit('applyFilter', this.selectedIds);
    } else {
      const mapIds: number[] = this.filterList.map((single) => single.id);
      this.selectedIds = this.mapOrder(this.selectedIds, mapIds);
      this.$emit('applyFilter', this.selectedIds);
    }
  }
}
</script>
<style lang="scss" module>
.applyMargin {
  margin-left: -2px;
}
.dropdownItem {
  border-bottom: 0.5px solid #dbdbdb;
}
.dropdownItem:last-child {
  border-bottom: unset;
}
</style>
